import React, { useState } from "react";
import { useStore } from "../../context";
import { navigate } from "@reach/router";
import { urlAuth, urlGetGrados, urlOpciones } from "../../utils";
import { httpGet } from "../../servicios";
import Swal from "sweetalert2";
import logoanai from "../../images/logos/logoanai.png";

const AuthMain = () => {
  const { dispatch } = useStore();
  const [user, setUser] = useState("");
  const [passw, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  function Login(event) {
    event.preventDefault();
    setLoading(true);
    const data = {
      username: "A" + user,
      password: passw,
    };
    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };

    fetch(`${urlAuth}auth/login`, options)
      .then((res) => res.json())
      .then(async (data) => {
        let _opciones = await httpGet(urlOpciones, data.token);
        let _grados = await httpGet(urlGetGrados, data.token);
        if (data.token) {
          dispatch({ type: "SET_OPCIONES", payload: _opciones.data });
          dispatch({ type: "SET_GRADOS", payload: _grados.data });
          dispatch({ type: "SET_TOKEN", payload: data });
          navigate("/menuMain");
        } else {
          Swal.fire({
            icon: "error",
            title: "Error de autenticación",
            text: "Credenciales incorrectas. Verifique su usuario y contraseña.",
            confirmButtonColor: "#0d1b3e",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("Error de promesa:", err);
        Swal.fire({
          icon: "error",
          title: "Error de conexión",
          text: "No se pudo conectar al servidor. Intente de nuevo.",
          confirmButtonColor: "#0d1b3e",
        });
      });
  }

  return (
    <div className="login-bg">
      <div className="login-card">
        <img src={logoanai} alt="ANAI Logo" className="login-logo" />
        <div className="login-title">Iniciar Sesión</div>
        <div className="login-subtitle">
          Sistema de pagos, inscripciones y matriculación de ANAI
        </div>

        <form noValidate onSubmit={Login}>
          <div className="modern-input-group">
            <label htmlFor="username">Usuario (Cédula o RUC)</label>
            <input
              type="text"
              id="username"
              placeholder="Ingrese su cédula o RUC"
              value={user}
              onChange={(e) => setUser(e.target.value)}
              autoFocus
              required
              title="Digite la cédula o ruc de la persona a quien se emite la factura en Colecturía"
            />
          </div>

          <div className="modern-input-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              placeholder="Ingrese su contraseña"
              value={passw}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              title="Si la clave no ha sido cambiada es la misma cédula o ruc"
            />
          </div>

          <button
            type="submit"
            className="btn-modern btn-primary"
            disabled={loading}
          >
            {loading ? (
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span className="spinner-ring" style={{ width: 22, height: 22, borderWidth: 3 }}></span>
                Ingresando...
              </span>
            ) : (
              "INGRESAR"
            )}
          </button>

          <button
            type="button"
            className="btn-modern btn-outline"
            onClick={() => navigate("/registroAnai")}
            title="Es sólo para aspirantes a cadetes"
          >
            Registro por primera vez
          </button>
        </form>

        <div style={{ textAlign: "center", marginTop: 20 }}>
          <span
            className="modern-link"
            onClick={() => navigate("/recuperaMenu")}
            title="Para recuperar la contraseña debe ingresar el codigo del estudiante@anai.edu.ec"
          >
            ¿Olvidó su contraseña?
          </span>
        </div>

        <div className="modern-copyright">
          {"© " + new Date().getFullYear() + " "}
          <a href="https://anai.edu.ec/" target="_blank" rel="noopener noreferrer">
            Academia Naval Almirante Illingworth
          </a>
          <br />
          <span style={{ fontSize: '0.75rem', color: '#999', marginTop: 4, display: 'inline-block' }}>Diseñado y Desarrollado por Departamento de Sistemas ANAI</span>
        </div>
      </div>
    </div>
  );
};

export default AuthMain;
